module.exports = __webpack_public_path__ + "img/dlp.7e87550.svg";